module.exports = __webpack_public_path__ + "img/accounts.3ec751b3.jpg";